import React from 'react';
import styled from 'styled-components';
import { ValidatorForm } from 'react-form-validator-core';

// eslint-disable-next-line react/display-name
const ContentFormBase = React.forwardRef((props, ref) => (
  <ValidatorForm noValidate instantValidate={false} {...props} ref={ref} />
));

const ContentForm = styled(ContentFormBase)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export default ContentForm;
